const allProductPaginations = document.querySelectorAll('.product__pagination');
const amountOfPaginations = allProductPaginations.length;
const productImagesContainer = document.querySelector('.product__grid-images')
const productImagesWrapper = document.querySelector('.product__grid-images-wrapper')
const productImageHeight = document.querySelector('.product-single__media').getBoundingClientRect().height
const observerThreshold = window.innerHeight < productImageHeight ? (window.innerHeight / productImageHeight - 0.05) : 0.9

const productImagesObserverOption = {
  // root: window,
  // rootMargin: ``,
  threshold: observerThreshold
}
const productImagesObserver = new IntersectionObserver(((entries, observer) => {
  if (entries[0].isIntersecting) {
    toggleProductPaginationActive(parseInt(entries[0].target.dataset.zoomId, 10) + 1)
  }
}), productImagesObserverOption);
document.querySelectorAll('.product-single__media > .product-featured-media').forEach(img => productImagesObserver.observe(img))

const toggleProductPaginationActive = (targetIndex) => {
  const targetPagination = document.querySelector(`.product__pagination[data-index='${targetIndex}']`);
  allProductPaginations.forEach(bullet => {
    bullet.classList.remove('active');
  })
  targetPagination.classList.add('active');
}

const scrollProductImages = (targetIndex) => {
  const wrapperTop = productImagesWrapper.getBoundingClientRect().top
  const target = document.querySelector(`.product-single__media-wrapper[data-image-index='${targetIndex}']`);
  const targetTop = target.getBoundingClientRect().top;
  productImagesContainer.scrollTo({
    top: targetTop - wrapperTop,
    behavior: 'smooth'
  })
  if (parseInt(targetIndex, 10) === amountOfPaginations) {
    // clicked on the last pagination bullet
    window.scrollTo({
      top: window.innerHeight * 0.3, // grid-images is 130vh on desktop, so its the 30vh we want to scroll down
      behavior: 'smooth'
    })
  } else {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }
}

allProductPaginations.forEach(bullet => bullet.addEventListener('click', () => scrollProductImages(bullet.dataset.index)))